var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStaplesactiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.63867 5C3.63867 4.44772 4.08639 4 4.63867 4H8.63867C9.19096 4 9.63867 4.44772 9.63867 5V9C9.63867 9.55228 9.19096 10 8.63867 10H4.63867C4.08639 10 3.63867 9.55228 3.63867 9V5Z",
    stroke: "#623CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.63867 15C3.63867 14.4477 4.08639 14 4.63867 14H8.63867C9.19096 14 9.63867 14.4477 9.63867 15V19C9.63867 19.5523 9.19096 20 8.63867 20H4.63867C4.08639 20 3.63867 19.5523 3.63867 19V15Z",
    stroke: "#623CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6387 5C13.6387 4.44772 14.0864 4 14.6387 4H18.6387C19.191 4 19.6387 4.44772 19.6387 5V9C19.6387 9.55228 19.191 10 18.6387 10H14.6387C14.0864 10 13.6387 9.55228 13.6387 9V5Z",
    stroke: "#623CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6387 15C13.6387 14.4477 14.0864 14 14.6387 14H18.6387C19.191 14 19.6387 14.4477 19.6387 15V19C19.6387 19.5523 19.191 20 18.6387 20H14.6387C14.0864 20 13.6387 19.5523 13.6387 19V15Z",
    stroke: "#623CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaplesactiveIcon);
export default __webpack_public_path__ + "static/media/staplesactiveIcon.26901d82bf952814406e8d227e9aab1c.svg";
export { ForwardRef as ReactComponent };